module.exports = __webpack_public_path__ + "static/media/52-iveco.a67a6d9f.jpg";